module.exports = __webpack_public_path__ + "img/meeting.07c8b32e.svg";